export const BOOLEAN_CUSTOM_FIELDS = [
  "splus",
];
